import { SVGProps } from 'react'
import * as React from 'react'

const StarsIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="150"
      height="148"
      viewBox="0 0 150 148"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M54.5801 0.0103302C54.4915 0.246666 53.9893 2.63955 53.487 5.32784C47.9627 33.6879 41.3454 43.0527 22.4387 49.2269C18.1551 50.6153 11.5968 52.2401 5.334 53.4809C2.6457 53.9831 0.252815 54.4853 0.0164814 54.5739C-0.219853 54.6626 2.11395 55.2534 5.18629 55.8738C24.093 59.7142 33.2214 63.4069 39.632 69.847C45.8357 76.0508 49.8239 85.8291 53.3098 103.259C53.9006 106.183 54.4619 108.901 54.5506 109.315C54.6687 109.787 55.1709 107.926 55.9981 103.85C59.8976 84.8542 63.354 76.3757 69.8532 69.847C73.9299 65.7703 78.5975 63.082 85.8353 60.5709C89.8529 59.1825 98.8041 56.9373 105.244 55.667C107.667 55.2239 109.528 54.7512 109.38 54.633C109.262 54.5444 107.992 54.2194 106.514 53.9536C86.8397 50.2608 76.2933 46.125 69.7646 39.5667C63.5017 33.2743 59.9272 24.6186 56.1754 6.45043C55.3777 2.66909 54.6687 -0.226006 54.5801 0.0103302Z"
        fill="#7181FF"
      />
      <path
        d="M114.963 77.7663C114.874 78.4162 113.043 86.7765 112.54 88.7854C111.654 92.2122 110.029 96.4662 108.641 98.8296C104.919 105.27 99.0399 108.519 86.4255 111.237C79.1878 112.803 79.3651 112.626 84.0622 113.571C94.9631 115.698 101.226 118.238 105.244 122.108C109.32 126.097 111.595 131.473 113.929 142.61C114.49 145.328 114.992 147.573 115.022 147.633C115.081 147.662 115.613 145.269 116.233 142.315C118.656 130.616 121.698 124.206 126.543 120.661C130.561 117.707 136.056 115.639 144.682 113.866C147.636 113.246 150.029 112.714 149.999 112.655C149.94 112.626 147.695 112.123 144.977 111.562C133.84 109.228 128.463 106.954 124.475 102.877C120.635 98.9182 118.242 93.0985 116.115 82.5225C115.258 78.3571 115.022 77.2936 114.963 77.7663Z"
        fill="#7181FF"
      />
    </svg>
  )
}

export default StarsIcon
